(function () {
  'use strict';

  var MAKE_PARAM = 'filter.p.m.custom.car_make';
  var MODEL_PARAM = 'filter.p.m.custom.car_model';
  var UNIVERSAL_VALUE = 'Universal';

  function getSelectedVehicle(quickFilter) {
    var makeSelect = quickFilter.querySelector('select[data-index="1"]');
    var modelSelect = quickFilter.querySelector('select[data-index="2"]');

    if (!makeSelect || !modelSelect) {
      return null;
    }

    var make = String(makeSelect.value || '').trim();
    var model = String(modelSelect.value || '').trim();

    if (!make || !model || model === UNIVERSAL_VALUE) {
      return null;
    }

    var makeOption = makeSelect.options[makeSelect.selectedIndex];
    var modelOption = modelSelect.options[modelSelect.selectedIndex];

    if (!makeOption || makeOption.getAttribute('data-filter-name') !== MAKE_PARAM) {
      return null;
    }

    if (!modelOption || modelOption.getAttribute('data-filter-name') !== MODEL_PARAM) {
      return null;
    }

    return {
      make: make,
      model: model
    };
  }

  function isCollectionVehiclePicker(quickFilter) {
    return !!quickFilter.closest('[data-lcm-vehicle-status]');
  }

  function isProductVehiclePicker(quickFilter) {
    return !!quickFilter.closest('[data-lcm-product-fitment]');
  }

  function getDestinationUrl(quickFilter) {
    if (isCollectionVehiclePicker(quickFilter)) {
      return new URL(window.location.pathname, window.location.origin);
    }

    var collectionUrl = quickFilter.getAttribute('data-collection-url');

    if (!collectionUrl) {
      return null;
    }

    return new URL(collectionUrl, window.location.origin);
  }

  function buildDestination(quickFilter, vehicle) {
    var url = getDestinationUrl(quickFilter);

    if (!url) {
      return null;
    }

    url.searchParams.delete(MAKE_PARAM);
    url.searchParams.delete(MODEL_PARAM);
    url.searchParams.append(MODEL_PARAM, vehicle.model);
    url.searchParams.append(MODEL_PARAM, UNIVERSAL_VALUE);

    return url.toString();
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest(
        'quick-filter[data-mode="filter"] .js-filter-submit'
      );

      if (!button) {
        return;
      }

      var quickFilter = button.closest('quick-filter[data-mode="filter"]');

      if (!quickFilter) {
        return;
      }

      var vehicle = getSelectedVehicle(quickFilter);

      if (!vehicle) {
        return;
      }

      /*
       * Op de productpagina blijft de bezoeker op hetzelfde product.
       * LCMVehicle verstuurt lcm:vehiclechange, waarna de fitmentbox
       * zichzelf direct opnieuw rendert.
       */
      if (isProductVehiclePicker(quickFilter)) {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (
          window.LCMVehicle &&
          typeof window.LCMVehicle.select === 'function'
        ) {
          window.LCMVehicle.select(vehicle, {
            reason: 'product-fitment'
          });
        }

        return;
      }

      var destination = buildDestination(quickFilter, vehicle);

      if (!destination) {
        return;
      }

      if (
        window.LCMVehicle &&
        typeof window.LCMVehicle.select === 'function'
      ) {
        window.LCMVehicle.select(vehicle, {
          reason: 'quick-filter'
        });
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(destination);
    },
    true
  );
})();
